{
  "next": "Next",
  "nextStep": "Next: {step}",
  "back": "Back",
  "backToStart": "Back to the start page",
  "submit": "Submit",
  "submitContinue": "Continue",
  "submitNextStepNote": "Registers your membership application. In the next step you choose how to activate direct debit.",
  "donationTypeMonthly": "Monthly",
  "donationTypeSingle": "One-time",
  "amountLabel": "Amount",
  "customAmount": "Custom amount",
  "minAmount": "Minimum amount is {min} {currency}",
  "perMonth": "{amount} kr/month",
  "firstName": "First name",
  "lastName": "Last name",
  "email": "Email",
  "mobile": "Mobile number",
  "ssn": "Personal ID number",
  "ssnPlaceholder": "YYYYMMDD-NNNN",
  "ssnHint": "For example 19940906-2388, used to register your gift and to try to fetch your postal address.",
  "membershipSsnHint": "For example 19940906-2388, used to register your membership and to try to fetch your postal address.",
  "ssnMissingHelp": "No personnummer, or would you rather not give one? Contact givarservice and we will help you:",
  "birthDate": "Date of birth",
  "birthDateHint": "A birthdate, yyyy-mm-dd, to verify that you are at least 18 years old.",
  "ssnOrBirthdateHint": "No Swedish personal identity number? Enter your date of birth instead.",
  "birthDatePlaceholder": "yyyy-mm-dd",
  "selectCountry": "Select country",
  "street": "Street address",
  "postcode": "Postcode",
  "city": "City",
  "country": "Country",
  "consentHeader": "Sign the direct-debit mandate",
  "consentSubtitle": "Sign with BankID or receive the mandate by post",
  "consentBankid": "Sign with BankID",
  "consentPostal": "Receive mandate by post",
  "bankidStarting": "Starting BankID …",
  "bankidPending": "Open the BankID app and sign",
  "bankidPendingIdentify": "Open the BankID app and identify yourself",
  "bankidComplete": "Signing complete",
  "bankidFailed": "Signing was cancelled",
  "bankidRetry": "Try again",
  "openBankid": "Open BankID",
  "errorGeneric": "Something went wrong. Please try again.",
  "formClosed": "This fundraiser is closed.",
  "formTryAgain": "Something went wrong for a moment. Please try again shortly.",
  "errorModalTitle": "Oh no, something went wrong!",
  "errorModalRetry": "Try again",
  "errorModalContact": "Feel free to contact givarservice:",
  "alreadyMemberTitle": "Already a member",
  "required": "This field is required",
  "invalidEmail": "Invalid email address",
  "invalidClearing": "The clearing number must be 4 digits",
  "invalidAccount": "The account number must be 4–12 digits",
  "invalidSsn": "Invalid personal ID number",
  "invalidMobile": "Invalid mobile number",
  "invalidPostcode": "Invalid postcode",
  "minorDisclaimer": "You must be at least 18 to become a monthly donor. You can instead ",
  "minorLinkYouth": "become an annual member.",
  "minorLinkChild": "join the Rädda Djuren club.",
  "giftTitle": "Which welcome gift would you like?",
  "giftSubtitle": "The gift will be sent to you by post",
  "skipGift": "I don't want a present",
  "enlargeGiftImage": "Show larger image: {title}",
  "chooseThisGift": "Choose present",
  "bankidSignMessage": "I approve a gift of {amount} SEK to Djurens Rätt every month, paid by direct debit (autogiro). This can be cancelled at any time by contacting Djurens Rätt.",
  "bankidSignMessageNoAmount": "I approve a direct debit (autogiro) mandate for Djurens Rätt. This can be cancelled at any time by contacting Djurens Rätt.",
  "thankYouTitle": "Thank you for your support!",
  "thankYouTitleCompany": "Thank you for your support!",
  "lookupCta": "Fetch my details",
  "lookupPending": "Fetching …",
  "lookupNotFound": "No details found — please fill in manually",
  "consentLinkNotFound": "We couldn't find a mandate to sign for this link. Check that you used the whole link from our message, or contact us and we'll help.",
  "lookupConfirm": "We found your details:",
  "lookupManual": "Enter manually instead",
  "lookupInstead": "Fetch my details instead",
  "enterManually": "Enter account number manually",
  "manualFallbackPrompt": "Would you rather",
  "manualFallbackLink": "enter your account details manually",
  "accountFetchPrompt": "How would you like to provide your account?",
  "useAccountConfirm": "Use this account",
  "bank": "Bank",
  "bankSelect": "Choose your bank",
  "bankOther": "Other bank",
  "fetchAccounts": "Fetch account via your bank",
  "fetchingAccounts": "Fetching account …",
  "accountsFailed": "Could not fetch account",
  "clearing": "Clearing number",
  "account": "Account number",
  "changeAccountPrefix": "Wrong account? You can",
  "changeAccountManual": "enter it manually",
  "changeAccountOr": "or",
  "changeAccountFetch": "fetch a different account",
  "clearingHint": "Usually 4 digits. Sparbankerna/Swedbank have 5 (NNNN-N) — enter it without the hyphen.",
  "sparbankWarning": "Make sure you pick the right one of Sparbanken Syd, Swedbank or Swedbank Sparbankerna. If one option doesn't work, try another.",
  "flowTitle": "Become a monthly donor",
  "progressLabel": "Progress",
  "stepOf": "Step {step} of {total}",
  "stepAmount": "Amount",
  "stepGift": "Gift",
  "stepDetails": "Your details",
  "stepAddress": "Address",
  "stepConsent": "Mandate",
  "stepPayment": "Payment",
  "thankYouBody": "You are now a monthly donor. Together we make a difference for the animals.",
  "thankYouBodyCompany": "You are now a monthly donor. Together we make a difference for the animals.",
  "donate": "Give a gift",
  "donationFlowTitle": "Give a gift",
  "choosePayment": "How would you like to pay?",
  "choosePaymentCompany": "How would you like to pay?",
  "paySwish": "Swish",
  "paySwishDesc": "Pay instantly with Swish",
  "payCard": "Card",
  "payCardDesc": "Pay by card",
  "payPostal": "Invoice",
  "payPostalDesc": "Receive an invoice by post",
  "redirecting": "Sending you to the payment …",
  "redirectingCompany": "Sending you to the payment …",
  "donationCancelled": "The payment was cancelled. You can try again.",
  "donationThankYouTitle": "Thank you for your gift!",
  "donationThankYouTitleCompany": "Thank you for your gift!",
  "donationThankYouBody": "Your gift makes a difference for the animals.",
  "donationPostalBody": "Your invoice will be sent to you by post. Thank you for your gift!",
  "integrityText": "To handle your membership and keep you informed about our work for animals, we store the information you provide. We do so in accordance with the data protection regulation, which means we guarantee that your information is protected and not disclosed to anyone else.",
  "integrityTextDonation": "To handle your gift and keep you informed about our work for animals, we store the information you provide. We do so in accordance with the data protection regulation, which means we guarantee that your information is protected and not disclosed to anyone else.",
  "integrityTextDonationCompany": "To handle your gift and keep you informed about our work for animals, we store the information you provide. We do so in accordance with the data protection regulation, which means we guarantee that your information is protected and not disclosed to anyone else.",
  "integrityTextPetition": "To register your signature and keep you informed about our work for animals, we store the information you provide. Your name and any comment become the signature we hand over in the campaign. We process the information in accordance with the data protection regulation, which guarantees that it is protected and not disclosed in any other way.",
  "integrityTextActivist": "To register you as a digital volunteer and keep you informed about our work for animals, we store the information you provide. We do so in accordance with the data protection regulation, which means we guarantee that your information is protected and not disclosed to anyone else.",
  "integrityMore": "Read more in our integrity policy",
  "integrityMoreLink": "integrity policy",
  "integrityUrl": "https://project1882.org/integrity",
  "annualFlowTitle": "Become an annual member",
  "stepCategory": "Membership",
  "chooseCategory": "Which membership would you like?",
  "categoryOrdinary": "Ordinary membership fee: 330 kr",
  "categoryOrdinaryDesc": "The strongest support for the animals❤️ Join in and make a bigger difference for them.",
  "categoryReduced": "Reduced membership fee: 150 kr",
  "categoryReducedDesc": "For you who are 18-25, a pensioner or on sickness benefit.",
  "categoryYouth": "Free membership fee: 0 kr",
  "categoryYouthDesc": "For you who are 14-17 and want to get involved for the animals.",
  "membershipTabDjurensRatt": "Djurens Rätt",
  "membershipTabChild": "For children",
  "membershipDjurensRattTitle": "Membership in Djurens Rätt",
  "membershipDjurensRattSubtitle": "It includes 4 member magazines a year. The membership renews yearly.",
  "membershipChildTitle": "Membership in Rädda Djuren-klubben",
  "membershipChildSubtitle": "A year's membership in Rädda Djuren-klubben is the perfect present for a child who cares about animals. It includes 5 member magazines a year and a present you can give the new member.",
  "membershipChildNote": "Use the button below to continue to Rädda Djuren-klubben's own site.",
  "youthBirthdateHint": "Enter your personal identity number or date of birth so we can confirm you are 14–17.",
  "youthAgeError": "Youth membership is for ages 14–17. Please choose another membership.",
  "youthFreeNote": "Youth membership is free of charge – you don't need to pay anything.",
  "becomeMember": "Become a member",
  "annualThankYouTitle": "Welcome as a member!",
  "annualThankYouBody": "Thank you for becoming an annual member. Together we make a difference for the animals.",
  "annualPostalBody": "Your invoice will be sent to you by post. Welcome as a member!",
  "annualYouthBody": "Your youth membership is now registered. Welcome!",
  "alreadyMember": "You are already a member. Contact our donor service if you have questions about your membership.",
  "notYouFillIn": "Not you? Fill in your own details",
  "giftedFlowTitle": "Give a gift",
  "stepGiftImage": "Motif",
  "stepGiftDetails": "Greeting",
  "stepDelivery": "Delivery",
  "giftcertTitle": "Recipient's name",
  "giftcertChooseTitle": "Which card do you want to send?",
  "giftcertChooseSubtitle": "Choose a motif",
  "giftcertTitlePlaceholder": "Who is the gift for?",
  "giftcertMessage": "Your greeting",
  "giftcertMessageHint": "Write a personal greeting to be printed on the gift certificate. Don't forget to write who it's from. Emoji can't be used.",
  "giftcertCharsLeft": "{count} characters left",
  "giftcertMessageNoEmoji": "The greeting must not contain emoji.",
  "giftcertMessageTooLong": "The greeting may be at most {max} characters.",
  "memorialHonoreeName": "Name of the person you wish to honour",
  "memorialHonoreeNameError": "Please enter the name of the person you wish to honour",
  "deliveryTitle": "How would you like the certificate delivered?",
  "deliveryDigital": "Digital",
  "deliveryPrinted": "Printed",
  "deliveryDigitalText": "The certificate is sent as a PDF to your email right after you pay.",
  "deliveryEmail": "Your email address",
  "deliveryPrintedText": "We print and post the gift certificate.",
  "deliveryRecipientHeading": "Who should receive the certificate?",
  "deliveryMailToMe": "Send the certificate to me instead",
  "deliverySendWhen": "When should the card be sent?",
  "deliverySendNow": "As soon as possible",
  "deliverySendDate": "Choose a send date",
  "deliverySendDateLabel": "Delivery date",
  "deliveryDateInvalid": "Choose a date from today onwards",
  "deliveryEstimate": "Estimated delivery between {range}.",
  "deliveryToMeTitle": "Post to you",
  "deliveryToMeText": "The gift certificate is posted to you and should arrive within five working days.",
  "deliveryToRecipientTitle": "Post to the recipient",
  "deliveryToRecipientText": "The gift certificate is posted to the recipient and should arrive within five working days from the chosen send date.",
  "deliveryOr": "or",
  "deliveryNote": "Note that delivery takes up to 3–5 working days. It can be affected by the postal service and public holidays.",
  "deliveryLastDateInfo": "For guaranteed delivery before {message}, order by {date}.",
  "deliveryAfterLastDate": "We can no longer guarantee delivery by {message}.",
  "deliverySwitchDigital": "Choose digital delivery instead – the certificate is emailed right after payment.",
  "giftcertThankYouTitle": "Thank you for your gift!",
  "giftcertThankYouBody": "Your gift certificate is on its way. Thank you for giving a gift to the animals.",
  "giftcertPostalBody": "Your invoice will be sent to you by post. Thank you for your gift!",
  "companyName": "Company name",
  "organisationNumber": "Registration number",
  "invoiceEmail": "Invoice email",
  "stepCompany": "Company",
  "perMonthSuffix": "/month",
  "payInvoice": "Invoice",
  "payInvoiceDesc": "Receive an invoice by email",
  "companyDonationFlowTitle": "Make a company gift",
  "recurringFlowTitle": "Become a monthly donor",
  "companyRecurringFlowTitle": "Become a monthly company donor",
  "recurringThankYouTitle": "Thank you for your monthly support!",
  "recurringThankYouTitleCompany": "Thank you for your monthly support!",
  "invoiceThankYouBody": "Your invoice is on its way. Thank you for supporting the animals!",
  "invoiceThankYouBodyCompany": "Your invoice is on its way. Thank you for supporting the animals!",
  "giftedMembershipFlowTitle": "Give a Rädda Djuren-klubben membership",
  "stepChild": "Recipient",
  "childDetailsTitle": "Who will become a member?",
  "childFirstName": "Child's first name",
  "childLastName": "Child's last name",
  "childBirthDate": "Child's date of birth",
  "childBirthDateHint": "The child must be 13 or younger",
  "childMustBeChild": "The child must be 13 or younger to join the club.",
  "sameAddressAsMe": "The child lives at the same address as me",
  "agentMustBeAdult": "You must be at least 18 to give a membership.",
  "becomeChildMember": "Give membership",
  "giftedMembershipThankYouTitle": "Thank you for your gift!",
  "giftedMembershipThankYouBody": "The Rädda Djuren-klubben membership is on its way. Thank you for giving the child a chance to help the animals.",
  "giftedMembershipPostalBody": "Your invoice will be sent to you by post. Thank you for giving a membership!",
  "giftedAnnualStepRecipient": "Recipient",
  "giftedAnnualStepGiftCard": "Gift certificate",
  "giftedAnnualRecipientTitle": "Who is the membership for?",
  "giftedAnnualRecipientSsn": "Recipient's personal identity number",
  "giftedAnnualRecipientLookupConfirm": "We found the recipient's details:",
  "giftedAnnualRecipientSsnHint": "For example 19940906-2388, used to register the membership on the right person and to try to fetch their postal address.",
  "giftedAnnualRecipientFirstName": "Recipient's first name",
  "giftedAnnualRecipientLastName": "Recipient's last name",
  "giftedAnnualRecipientBirthDate": "Recipient's date of birth",
  "giftedAnnualSameAddress": "The recipient lives at the same address as me",
  "giftedAnnualCategoryTitle": "Which membership should the recipient get?",
  "giftedAnnualPresentTitle": "Which welcome gift would you like to give?",
  "giftedAnnualGiftCardTitle": "Which gift certificate would you like to give?",
  "giftedAnnualGiftCardSubtitle": "The gift certificate is sent to you by post.",
  "giftedAnnualBuyerTitle": "Who are you, giving the membership?",
  "giftedAnnualSubmit": "Give the membership",
  "giftedAnnualThankYouTitle": "Thank you for giving a membership!",
  "giftedAnnualThankYouBody": "Together we make a difference for the animals.",
  "giftedAnnualPostalBody": "The invoice will be sent to you by post.",
  "giftedAnnualYouthBody": "The youth membership is registered.",
  "giftedAnnualAlreadyMember": "The recipient is already a member of Djurens Rätt. Contact our donor service if you have any questions.",
  "raiseAmountTitle": "Raise your monthly amount",
  "raiseAmountIntro": "As a monthly donor to Djurens Rätt you can easily raise your monthly amount.",
  "raiseAmountIdentifyTitle": "Identify yourself",
  "raiseAmountIdentifyIntro": "Sign in with BankID and we will fetch your membership.",
  "raiseAmountIdentifyCta": "Identify with BankID",
  "raiseAmountChooseTitle": "Choose a new monthly amount",
  "raiseAmountCurrent": "Your current amount: {amount} kr/month",
  "raiseAmountSameError": "That is the same amount as before. Please choose a different amount.",
  "raiseAmountMustBeHigher": "You already give {current} {currency}/mo. Choose a higher amount to raise it.",
  "raiseAmountMustBeHigherUnknown": "The new amount must be higher than your current one.",
  "raiseAmountUnavailable": "We could not confirm whether the change went through. Please try again shortly — sending the same amount again changes nothing if it already applied.",
  "raiseAmountNotFound": "We could not find your membership. Please check your details and try again.",
  "raiseAmountSubmit": "Confirm new amount",
  "raiseAmountSuccessTitle": "Your monthly amount has changed",
  "raiseAmountSuccessBody": "Your new monthly gift is {amount} kr/month. Thank you for your support!",
  "raiseAmountAltToggle": "Identify yourself another way",
  "raiseAmountHelp": "Stuck? Email",
  "raiseAmountAltMemberNumberHint": "Your member number is in our letters and on the back of the Djurens Rätt magazine.",
  "raiseAmountAltMobileHint": "The number you have registered with us, e.g. +46xxxxxxxxx.",
  "raiseAmountAltCodeHint": "The six-digit code in the text message.",
  "raiseAmountAltEmailHint": "The address you have registered with us.",
  "raiseAmountAltSsnHint": "For example 19940906-2388, used to confirm it is you.",
  "raiseAmountAltInvalidCode": "The code is six digits.",
  "raiseAmountAltTabSms": "Text code",
  "raiseAmountAltTabEmail": "Email link",
  "raiseAmountAltTabMember": "Member number",
  "raiseAmountAltMobileLabel": "Mobile number",
  "raiseAmountAltSmsCta": "Send code",
  "raiseAmountAltSmsSent": "If we have {mobile}, we have sent a code to it. The code is valid for 10 minutes.",
  "raiseAmountAltCodeLabel": "Code",
  "raiseAmountAltCodeCta": "Sign in",
  "raiseAmountAltWrongCode": "The code is not right. Check it and try again.",
  "raiseAmountAltCodeExpired": "The code has expired. Ask for a new one.",
  "raiseAmountAltEmailLabel": "Email address",
  "raiseAmountAltEmailCta": "Send link",
  "raiseAmountAltEmailSent": "If we have {email}, we have sent a link to it. The link is valid for 30 minutes.",
  "raiseAmountAltLinkExpired": "The link has expired. Sign in again below.",
  "raiseAmountSignedInAs": "Signed in as {name}",
  "raiseAmountNotYou": "Not you?",
  "raiseAmountAltMemberNumberLabel": "Membership number",
  "raiseAmountAltSsnLabel": "Personal identity number",
  "raiseAmountAltMemberCta": "Sign in",
  "raiseAmountAltMemberNoMatch": "The membership number and personal identity number do not match. Check them and try again.",
  "raiseAmountAltRateLimited": "You have tried too many times. Wait a while and try again.",
  "raiseAmountAltChangeMobile": "Change number",
  "raiseAmountAltUnavailable": "We couldn't sign you in just now. Please try again in a moment.",
  "recommended": "Recommended",
  "surveyBack": "Back",
  "surveyBlixtCta": "Subscribe to Blixtmail",
  "surveyBlixtSendsTo": "Blixtmail goes to {email}.",
  "surveyBlixtTitle": "Become a Blixt – take digital action for animals!",
  "surveyBlixtBody": "As a digital volunteer you take quick online actions for animals – small tasks that make a real difference. You'll get the tasks by email and can also use our BlixtApp, which is continuously filled with activities.",
  "surveyBlixtMoreLabel": "What does a digital volunteer do?",
  "surveyBlixtFact1": "Signs petitions for the animals",
  "surveyBlixtFact2": "Sends flash emails to companies and decision-makers",
  "surveyBlixtFact3": "Shares and spreads messages on social media",
  "surveyBlixtDone": "Thanks! You're now a Blixt.",
  "surveyBlixtOpenApp": "Open the BlixtApp",
  "surveyBlixtError": "Something went wrong. Please try again.",
  "surveyChannelEmail": "email",
  "surveyQuestionBadge": "Question {n}",
  "surveyAmountChip": "{amount} SEK",
  "surveyAmountGroupSwish": "Give once with Swish",
  "surveyAmountGroupMonthly": "Give monthly",
  "surveyShareDecline": "No thanks",
  "surveyShareVia": "via",
  "surveyShareLinkLabel": "Link to share",
  "surveyShareCopy": "Copy the link",
  "surveyShareCopied": "Link copied",
  "opensInNewTab": "(opens in a new tab)",
  "petitionStepMessage": "Message",
  "petitionMessagePlaceholder": "Write a message (optional)",
  "petitionMessageLabel": "Your message",
  "petitionNewsletterOptIn": "Yes, please send me the newsletter",
  "petitionSubmit": "Sign the petition",
  "petitionThankYouTitle": "Thank you for signing!",
  "petitionThankYouBody": "Your signature has been recorded.",
  "petitionAlreadySigned": "You have already signed.",
  "petitionErrorMessage": "Something went wrong. Please try again.",
  "loading": "Loading",
  "secondAskSigningAs": "Signing as",
  "secondAskPetitionTitle": "Sign the petition",
  "petitionMotivationLabel": "Tell us why you're signing (optional, shown here on the page)",
  "petitionBlixtmailOptIn": "Yes, I'd like to get Blixtmail once a week with tips on actions for the animals.",
  "petitionProgressLabel": "{count} signatures – next we're aiming for {goal}!",
  "secondAskAlreadySigned": "You have already signed",
  "secondAskDonateWithSwish": "Pay {amount} {currency} with Swish",
  "secondAskDonateWithCard": "Pay {amount} {currency} by card",
  "secondAskSwishTo": "The Swish request goes to {mobile}.",
  "secondAskSwishChange": "Change number",
  "secondAskSwishWrongNumber": "Wrong number? Change it",
  "secondAskPaymentCancelled": "The payment was cancelled. Try again, or change the number if it was wrong.",
  "secondAskBecomeMonthly": "Become a monthly donor at {amount} kr/mo",
  "secondAskRaiseTo": "Raise to {amount} kr/mo",
  "secondAskCurrentMonthly": "You currently give {amount} kr/month",
  "secondAskDonorAs": "Giving as",
  "secondAskMembershipSuccess": "Welcome as a monthly donor!",
  "secondAskRaiseSuccess": "Your monthly amount has been updated",
  "secondAskDonationTitle": "Support the animals with a gift",
  "secondAskMonthlyTitle": "Become a monthly donor",
  "shopBuyNow": "Buy now",
  "shopSoldOut": "Sold out",
  "shopViewInStore": "View in store",
  "shopVariant": "Variant",
  "shopNoProducts": "No products to show right now.",
  "shopMemberPrice": "Member price",
  "bankidQrEnlargedTitle": "Scan the QR code",
  "bankidQrEnlargedLabel": "Enlarged BankID QR code",
  "bankidQrEnlargedHint": "Open the BankID app on your phone and scan the code.",
  "bankidQrAlt": "QR code to scan with the BankID app",
  "bankidEnlargeQr": "Enlarge the QR code",
  "bankidExtend": "Give me more time",
  "bankidExpired": "Time ran out",
  "close": "Close",
  "actStepStart": "Information",
  "actStepAmount": "Donation",
  "actStepDetails": "Personal information",
  "actStepAddress": "Postal address",
  "actStepPayment": "Payment options",
  "actAmountTitle": "How much would you like to donate for the animals?",
  "actDetailsTitle": "Your payment information",
  "actDetailsSubtitle": "Fill out your details",
  "actAddressTitle": "What is your postal address?",
  "actAddressSubtitle": "Retrieved data",
  "actAddressSubtitleManual": "Fill out your details",
  "actPaymentTitle": "How would you like to pay your gift to the animals?",
  "actPaymentSubtitle": "Choose your payment method",
  "actPaymentTitleSingle": "Everything is ready",
  "actPaymentSubtitleSingle": "Let’s make that donation for the animals",
  "actAmountEyebrow": "My donation for the animals",
  "actAmountEyebrowCompany": "Our donation for the animals",
  "actAmountHint": "Choose donation amount",
  "actAmountOther": "Other",
  "actAmountCustomLabel": "Choose donation amount",
  "actAmountCustomLabelCompany": "Choose donation amount",
  "actSingle": "One-time donation",
  "actMonthly": "Monthly donation",
  "actSsnPlaceholder": "yyyymmdd-nnnn",
  "actSsnHint": "A Swedish social security number (personnummer), yyyymmdd-nnnn",
  "actNoSsn": "I don’t have a Swedish social security number",
  "actHasSsn": "I have a Swedish social security number",
  "actBirthDateHint": "A birthdate, yyyy-mm-dd",
  "actMobileHint": "Enter your mobile number without dashes or spaces, for example +46xxxxxxxxx",
  "actFillOther": "Fill in other details",
  "actLookupName": "Name",
  "actLookupChangeAddress": "Fill in other details",
  "actLookupUseFetched": "Use the retrieved details",
  "actLookupBannerPending": "Fetching your details …",
  "actLookupBannerFound": "We found your details!",
  "actLookupBannerFailed": "Could not look up your address!",
  "actPaySwish": "Swish",
  "actPaySwishDesc": "Smooth and easy, we recommend!",
  "actPayCard": "Card",
  "actPayCardDesc": "Drawn directly, smoothly!",
  "actPayCardDescCompany": "Drawn directly, smoothly!",
  "actPayPostal": "Invoice",
  "actPayPostalDesc": "Get an invoice by post",
  "actPayBySwish": "Pay by Swish",
  "actPayByCard": "Pay by card",
  "actPayByPostal": "Pay",
  "actReadMore": "Read more",
  "videoPlay": "Play video",
  "videoPause": "Pause video",
  "completing": "One moment …",
  "actConsentTitle": "Sign your direct debit mandate",
  "actConsentSubtitle": "Choose how you want to sign",
  "actConsentBankid": "BankID",
  "actConsentBankidDesc": "Sign quickly with BankID",
  "actConsentPostal": "Paper form",
  "actConsentPostalDesc": "Get a form in the post",
  "actBankTitle": "Fetch bank account",
  "actBankTitleManual": "Enter your bank details",
  "actBankTitleFetched": "Your fetched bank details",
  "actBankSubtitle": "Direct debit only works with some accounts, so please check with your bank that yours supports it",
  "actSignTitle": "Sign with BankID",
  "actSignSubtitle": "By signing I accept these terms",
  "actConsentOtherMethod": "Choose another way to sign",
  "actMonthlyStepAmount": "Amount",
  "actMonthlyStepAddress": "Address",
  "actPerMonthSuffix": "/month",
  "actStepBank": "Bank",
  "actStepSign": "Sign"
}
